import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet'; 
import Spinner from '../../Spinner';
import ContentRenderer from '../../ContentRenderer';

function Tutorial({ doc: { html, meta } = {}, handleRender }) {
  if (!html) {
    return <Spinner />;
  }

  return (
    <div className="docs-content quickstart-docs-content">
      <Helmet>
        <meta name="robots" content={meta.beta ? 'noindex, nofollow' : 'all'} />
      </Helmet>
      <ContentRenderer
        html={html}
        meta={meta}
        afterRender={handleRender}
      />
    </div>
  );
}

Tutorial.propTypes = {
  doc: PropTypes.object,
  handleRender: PropTypes.func.isRequired
};

export default Tutorial;
